const React = require('react');

const InfoBox = React.createClass({

    render: function() {
     	return (
     		<div className="info-boxes">
                <div className="box-wrapper">
                    <div className={"box " + this.props.colorClass}>
                        <div className="heading">{this.props.title}</div>
                        <div className="body">
                            <span>{this.props.content}</span>
                        </div>
                        <div className="footing">{this.props.bottom}</div>
                    </div>
                </div>
            </div>
 		);
    }
});

exports.InfoBox = InfoBox;